module.exports= {
	poi_cluster: require("./poi_cluster.png")
};